import { keyBy } from "lodash";
import { axios } from "../connection/ConnectionHandler";
import { DELETE_ALERT, SET_ALERT_LIST } from "../constants";
import { API } from "../constants/api";
import { formatAlerts } from "./settingsActionsUtils";

export const fetchAlerts = () => async (dispatch) =>
	axios
		.get(API.alerts.list)
		.then((response) => {
			dispatch({ type: SET_ALERT_LIST, payload: keyBy(formatAlerts(response.data), "_id") });
			return response.status;
		})
		.catch((err) => err);

export const deleteAlerts = (ids) => async (dispatch) =>
	axios
		.delete(API.alerts.delete, { data: ids })
		.then((response) => {
			dispatch({ type: DELETE_ALERT, payload: ids });
			return response.status;
		})
		.catch((err) => err);
